import { APP_BASE_HREF, registerLocaleData } from '@angular/common'
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import localeFr from '@angular/common/locales/fr'
import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom, isDevMode, LOCALE_ID, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core'
import { provideRouter } from '@angular/router'
import { provideServiceWorker } from '@angular/service-worker'
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core'
import { ApiInterceptor } from 'src/app/core/interceptors/api.interceptor'
import { routes } from './app.routes'
import { provideAnimations } from '@angular/platform-browser/animations'
import { environment } from 'src/environments/environment'
import { CustomTranslateLoader, I18N_LANGUAGES, I18N_PATH, initTranslations } from '@corporate-tailwind/translation'

registerLocaleData(localeFr)
export const appConfig: ApplicationConfig = {
    providers: [
        { provide: LOCALE_ID, useFactory: () => navigator.language },
        { provide: APP_BASE_HREF, useValue: '/myfxorder/' },
        provideBrowserGlobalErrorListeners(),
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes),
        provideAnimations(),
        provideServiceWorker('ngsw-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerWhenStable:30000'
        }),
        provideHttpClient(
            ...(environment.enableHttpInterceptors ? [withInterceptorsFromDi()] : [])
        ),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ApiInterceptor,
            multi: true
        },
        { provide: I18N_PATH, useValue: './i18n/app-front/' },
        importProvidersFrom(
            TranslateModule.forRoot({
                fallbackLang: 'fr',
                loader: {
                    provide: TranslateLoader,
                    useFactory: (http: HttpClient, path: string) => new CustomTranslateLoader(http, path),
                    deps: [HttpClient, I18N_PATH, I18N_LANGUAGES]
                }
            })
        ),
        { provide: I18N_LANGUAGES, useValue: ['fr', 'uk', 'de', 'nl'] },
        {
            provide: APP_INITIALIZER,
            useFactory: initTranslations,
            deps: [TranslateService, I18N_LANGUAGES],
            multi: true
        }
    ]
}
